/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import type { QuoteItemSection } from '../..'
import { removeItem } from './remove-item'

export function removeItems(args: {
  quote: QuoteDocument
  options: OptionsDocument
  keys: string[]
  section?: QuoteItemSection
}): QuoteDocument {
  const { quote, options, keys, section } = args

  return keys.reduce(
    (updatedQuote: QuoteDocument, key: string) => {
      return removeItem({ quote: updatedQuote, options, key, section })
    },
    { ...quote }
  )

  return null
}
